/**
 * 選定支援事例 金額
 */
/** 金額: 1,000万円以下 値 */
export const CASE_PRICE_TEN_MILLION_LESS_VALUE = 1;
/** 金額: 2,000万円以下 値 */
export const CASE_PRICE_TWENTY_MILLION_LESS_VALUE = 2;
/** 金額: 3,000万円以下 値 */
export const CASE_PRICE_THIRTY_MILLION_LESS_VALUE = 3;
/** 金額: 1,000万円以下 */
export const CASE_PRICE_TEN_MILLION_LESS = {
    filter: {
        max: 1000,
        min: 0,
    },
    label: '1,000万円以下',
    value: CASE_PRICE_TEN_MILLION_LESS_VALUE,
};
/** 金額: 2,000万円以下 */
export const CASE_PRICE_TWENTY_MILLION_LESS = {
    filter: {
        max: 2000,
        min: 1001,
    },
    label: '1,000万円以上 ~ 2,000万円以下',
    value: CASE_PRICE_TWENTY_MILLION_LESS_VALUE,
};
/** 金額: 3,000万円以下 */
export const CASE_PRICE_THIRTY_MILLION_LESS = {
    filter: {
        max: 3000,
        min: 2001,
    },
    label: '2,000万円以上 ~ 3,000万円以下',
    value: CASE_PRICE_THIRTY_MILLION_LESS_VALUE,
};
/**
 * 金額絞り込みの設定 配列
 */
export const CASE_PRICES = [
    CASE_PRICE_TEN_MILLION_LESS,
    CASE_PRICE_TWENTY_MILLION_LESS,
    CASE_PRICE_THIRTY_MILLION_LESS,
];
/**
 * 金額絞り込みの値 配列
 */
export const CASE_PRICES_VALUES = [
    CASE_PRICE_TEN_MILLION_LESS_VALUE,
    CASE_PRICE_TWENTY_MILLION_LESS_VALUE,
    CASE_PRICE_THIRTY_MILLION_LESS_VALUE,
];
